import { isTableLabel } from "../../helpers";
import { Zone } from "../../types";
import { PageSaveState, PageState, State } from "../state";

export interface ChangeCurrentLabelAction {
  label: string;
  type: "CHANGE CURRENT LABEL";
}

export const changeCurrentLabelOnPage = (
  state: PageState,
  action: ChangeCurrentLabelAction,
  taxonomy: State["taxonomy"],
): PageState => {
  if (state.activeZones.length < 1) {
    return state;
  }
  const newZones = state.zones.reduce((prev, next, index) => {
    if (state.activeZones.indexOf(index) < 0) {
      return prev;
    }
    const newZone = { ...next, label: action.label };
    if (isTableLabel(action.label, taxonomy)) {
      if  (!Array.isArray(newZone.cells)) {
        newZone.cells = [
          {
            maxX: newZone.maxX,
            maxY: newZone.maxY,
            minX: newZone.minX,
            minY: newZone.minY,
          },
        ];
      }
    } else {
      newZone.cells = undefined;
    }
    if (prev !== state.zones) {
      prev[index] = newZone;
      return prev;
    }
    return [...prev.slice(0, index), newZone, ...prev.slice(index + 1)];
  }, state.zones as Array<Zone>);
  if (newZones === state.zones) {
    return state;
  }
  return {
    ...state,
    pageSaveState: PageSaveState.Dirty,
    zones: state.zoneHistory.push(newZones),
  };
};

export const changeCurrentLabel = (state: State, action: ChangeCurrentLabelAction): State => {
  if (action.label === "" || action.label === state.currentLabel) {
    return state;
  }
  let pages = state.pages;
  const updatedPage = changeCurrentLabelOnPage(
    state.pages[state.activePage],
    action,
    state.taxonomy,
  );
  if (updatedPage !== state.pages[state.activePage]) {
    pages = [
      ...pages.slice(0, state.activePage),
      updatedPage,
      ...pages.slice(state.activePage + 1),
    ];
  }
  return {
    ...state,
    currentLabel: action.label,
    currentLabelGroup: "",
    pages,
  };
};
